import { useTranslation } from '../../../hooks/useTranslation';
import { AgentMetricsUnit } from '../../../interfaces/Agent';
import AgentMetric from '../AgentMetric/AgentMetric';
import StyledOverAllMetrics from '../OverAllMetrics/StyledOverAllMetrics';

interface ChatOverAllMetricsProps {
  averageSatisfaction?: number;
  totalConversations?: number;
  totalMessages?: number;
  averageSeconds?: number;
  averageMessages?: number;
  isRefreshing?: boolean;
}

const ChatOverAllMetrics: React.FC<ChatOverAllMetricsProps> = ({
  averageSatisfaction = 0,
  totalConversations = 0,
  totalMessages = 0,
  averageSeconds = 0,
  averageMessages = 0,
  isRefreshing = false,
}) => {
  const { t } = useTranslation();

  return (
    <StyledOverAllMetrics>
      <AgentMetric
        value={totalMessages}
        label={t('Messages')}
        flexDirection="column-reverse"
        fontSize="2.5rem"
        alignItems="center"
        isRefreshing={isRefreshing}
      />
      <AgentMetric
        value={totalConversations}
        label={t('Conversations')}
        flexDirection="column-reverse"
        fontSize="2.5rem"
        alignItems="center"
        isRefreshing={isRefreshing}
      />
      <AgentMetric
        unit={AgentMetricsUnit.PERCENT}
        value={averageSatisfaction}
        label={t('Satisfaction')}
        flexDirection="column-reverse"
        fontSize="2.5rem"
        alignItems="center"
        isRefreshing={isRefreshing}
      />
      <AgentMetric
        value={Math.round(averageSeconds)}
        label={t('Avg Seconds')}
        flexDirection="column-reverse"
        fontSize="2.5rem"
        alignItems="center"
        isRefreshing={isRefreshing}
      />
      <AgentMetric
        value={Math.round(averageMessages * 10) / 10}
        label={t('Avg Messages')}
        flexDirection="column-reverse"
        fontSize="2.5rem"
        alignItems="center"
        isRefreshing={isRefreshing}
      />
    </StyledOverAllMetrics>
  );
};

export default ChatOverAllMetrics;
